/* PDP gallery fixes (Letifly)
 * 1. Keep carousel references live after the gallery is re-rendered on variant change.
 * 2. Clicking a thumbnail that is a variant image selects that variant.
 */
(function () {
  function liveCarousel(s) { return document.querySelector('sht-carousel[data-section-id="' + s + '"]'); }
  function liveThumb(s) { return document.querySelector('sht-slideshow-carousel[data-section="' + s + '"]'); }
  function selectorFor(s) { return document.querySelector('sht-variant-selects[data-section="' + s + '"], sht-variant-radios[data-section="' + s + '"]'); }

  /* ---- 1. live references ---- */
  function patch(obj, s) {
    Object.defineProperty(obj, 'carousel', { configurable: true, get: function () { return liveCarousel(s); }, set: function () {} });
    Object.defineProperty(obj, 'thumb_carousel', { configurable: true, get: function () { return liveThumb(s); }, set: function () {} });
  }
  function fix() {
    document.querySelectorAll('sht-prd-slideshow').forEach(function (ss) {
      if (ss.__thumbFix) return;
      ss.__thumbFix = true;
      patch(ss, ss.dataset.section);
    });
    document.querySelectorAll('sht-variant-selects, sht-variant-radios').forEach(function (v) {
      if (!v.elms || v.__thumbFix) return;
      v.__thumbFix = true;
      patch(v.elms, v.dataset.section);
    });
  }

  /* ---- 2. thumbnail -> variant ---- */
  function sizeToken(value) {
    var m = String(value || '').trim().match(/\b(XS|S|M|L|XL|XXL)$/i);
    return m ? m[1].toUpperCase() : null;
  }
  function pickVariant(candidates, current) {
    if (!current) return candidates[0];
    var best = null, bestScore = -1;
    candidates.forEach(function (v) {
      var score = 0;
      v.options.forEach(function (opt, i) {
        if (opt === current.options[i]) score += 10;
        else if (sizeToken(opt) && sizeToken(opt) === sizeToken(current.options[i])) score += 5;
      });
      if (v.available) score += 1;
      if (score > bestScore) { bestScore = score; best = v; }
    });
    return best || candidates[0];
  }
  function applyVariant(selector, variant) {
    var changed = false;
    if (selector.tagName.toLowerCase() === 'sht-variant-selects') {
      selector.querySelectorAll('.js-variant-select-item').forEach(function (sel, i) {
        if (sel.value !== variant.options[i]) {
          sel.value = variant.options[i];
          changed = true;
          var wrap = sel.closest('sht-select');
          if (wrap && typeof wrap.updateSelectedItem === 'function') wrap.updateSelectedItem();
        }
      });
    } else {
      selector.querySelectorAll('.js-variant-radio-container').forEach(function (group, i) {
        var radio = Array.prototype.find.call(group.querySelectorAll('.js-variant-radio-item'), function (r) { return r.value === variant.options[i]; });
        if (radio && !radio.checked) { radio.checked = true; changed = true; }
      });
    }
    if (changed) selector.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function onThumbClick(e) {
    var btn = e.target.closest('.js-slideshow-btn-thumb');
    if (!btn) return;
    var target = btn.dataset.target || '';
    var cut = target.lastIndexOf('-');
    if (cut < 0) return;
    var section = target.slice(0, cut), mediaId = target.slice(cut + 1);
    var selector = selectorFor(section);
    if (!selector || typeof selector.getVariantData !== 'function') return;
    var variants;
    try { variants = selector.getVariantData(); } catch (err) { return; }
    var candidates = variants.filter(function (v) { return v.featured_media && String(v.featured_media.id) === mediaId; });
    if (!candidates.length) return; /* lifestyle image: leave the variant alone */
    var current = selector.currentVariant;
    if (current && candidates.some(function (v) { return v.id === current.id; })) return; /* already on this image */
    applyVariant(selector, pickVariant(candidates, current));
  }

  function start() {
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', onThumbClick, true);
  }
  Promise.all([
    customElements.whenDefined('sht-prd-slideshow'),
    customElements.whenDefined('sht-variant-selects')
  ]).then(function () {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  });
})();
